module.exports = __webpack_public_path__ + "static/media/icn_close_gray.0e428acd.svg";